import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const HeaderLink = styled(Link)`
  display: flex;
`;

export const LogoImage = styled.img`
  height: 100%;
`;
